/**
 * Interfeys tillari — yagona ro'yxat.
 *
 * Ilgari til ro'yxati bir necha joyda alohida yozilgan edi: sarlavhadagi
 * tanlagichda, sozlamalar oynasida va tarjima yordamchisida. Natijada bir
 * joyda o'zgartirilsa boshqasi eskiligicha qolib ketardi. Endi hammasi
 * shu fayldan oladi.
 */

export type UiLang = "uz" | "ru" | "en"

export interface UiLangInfo {
  code: UiLang
  /** Ro'yxatda kod yonida turadigan bayroqcha */
  flag: string
  /** To'liq nom — faqat kerak bo'lgan joyda (masalan AI tarjimasi) */
  label: string
  /** AI ga qaysi tilda javob berishni aytish uchun */
  promptName: string
}

export const UI_LANGS: UiLangInfo[] = [
  { code: "uz", flag: "🇺🇿", label: "O'zbekcha", promptName: "Uzbek (latin script)" },
  { code: "ru", flag: "🇷🇺", label: "Русский", promptName: "Russian" },
  { code: "en", flag: "🇬🇧", label: "English", promptName: "English" },
]

export const DEFAULT_UI_LANG: UiLang = "ru"

/** Tanlangan interfeys tili. Noma'lum qiymat kelsa standart til qaytadi. */
export function currentUiLang(): UiLang {
  const raw = (localStorage.getItem("i18nextLng") || DEFAULT_UI_LANG).split("-")[0]
  const found = UI_LANGS.find((l) => l.code === raw)
  return found ? found.code : DEFAULT_UI_LANG
}

export function langInfo(code: UiLang): UiLangInfo {
  return UI_LANGS.find((l) => l.code === code) || UI_LANGS[1]
}
